import {
    Button,
    IconButton as MuiIconButton,
    Typography,
    Box as MuiBox,
    styled,
} from "@mui/material"

import { CloseIcon as Close } from "@l2r-front/l2r-icons"

import { ScrollableLayout } from "../../layouts/ScrollableLayout"

type StyledBoxProps = {
    height?: string | number
    width?: string | number
    isMobile?: boolean
}

export const Box = styled(MuiBox, {
    shouldForwardProp: (prop) => prop !== "isMobile" && prop !== "height" && prop !== "width"
})<StyledBoxProps>
    (({ theme, height, width, isMobile }) => ({
        backgroundColor: theme.palette["common/white_states"].main,
        borderRadius: !isMobile ? theme.spacing(8) : undefined,
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        height: isMobile ? "100%" : height,
        maxHeight: isMobile ? "100%" : "90%",
        justifyContent: "center",
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        width: isMobile ? "100%" : width,
        maxWidth: isMobile ? "100%" : "80%",
        padding: isMobile ? theme.spacing(6) : theme.spacing(8),
        position: "absolute",
        margin: "auto",
    }))

export const Title = styled(Typography)(() => ({
    textAlign: "left",
    flex: "1 1 auto",
}))

export const Desc = styled(Typography)(({ theme }) => ({
    marginBottom: theme.spacing(5),
}))

export const IconButton = styled(MuiIconButton)(() => ({
    padding: 0,
    height: 24,
    width: 24,
}))

export const CloseIcon = styled(Close)(({ theme }) => ({
    color: theme.palette["common/black_states"].main,
    height: 24,
    width: 24,
}))

export const Header = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    gap: theme.spacing(3),
    marginBottom: theme.spacing(8),
}))

export const TitleIcon = styled("div")(({ theme }) => ({
    color: theme.palette["common/black_states"].main,
    height: 28,
    width: 28,
    marginRight: theme.spacing(3),
}))

interface ButtonsContainerProps {
    isMobile?: boolean
}

export const ButtonsContainer = styled("div")<ButtonsContainerProps>(({ isMobile, theme }) => ({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: isMobile ? "space-between" : "flex-end",
    gap: theme.spacing(6),
    marginTop: theme.spacing(8),
}))

export const BackButton = styled(Button)(({ theme }) => ({
    minWidth: "unset",
    width: "fit-content",
    textTransform: "initial",
    padding: 0,
    marginRight: theme.spacing(9),
}))

export const Content = styled("div")(() => ({
    display: "flex",
    flex: "1 1 auto",
    minHeight: 0,
}))

export const Layout = styled(ScrollableLayout)(() => ({
    height: "100%",
}))

export const LoaderMask = styled("div")(() => ({
    position: "absolute",
    inset: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "rgba(255, 255, 255, 0.7)",
    zIndex: 10,
}))

export const LoaderContainer = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: theme.spacing(1),
}))